import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";

export default function TermsPage() {
  return (
    <PageContainer
      className="h-full w-full app-bar-bottom-padding overflow-y-auto no-scrollbar"
      showLogo={true}
    >
      <div className="w-full h-full mt-4 flex flex-col items-start gap-8">
        <PageTitleComponent title="Terms of Service" />
        <span className="text-gray-600 text-sm">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam,
          quos.
        </span>
      </div>
    </PageContainer>
  );
}
